import React from "react";
import { MDBRow, MDBCol, MDBView, MDBAnimation } from "mdbreact";
import Imagen_play_store from "../../../../images/CTA-google.png";
import Imagen_app_store from "../../../../images/CTA-Apple.png";

class Start extends React.Component {
  render() {
    return (
      <div id="apppage">
        <MDBView className="view-homepage">
          <MDBRow
            style={{
              paddingTop: "80px",
              paddingBottom: "30px",
            }}>
            <MDBCol lg="12" md="12" sm="12">
              <MDBAnimation type="fadeInLeft" delay=".3s" align="left">
                <div style={{
                    display: "flex",
                    justifyContent: "center"
                  }}>
                  <div className="col-lg-8 col-md-8 col-sm-8">
                    <p className="mt-2 f_heading">
                      Viaja más <span style={{color: "#fed700"}}>fácil, cómodo y seguro</span> con rutas
                      compartidas a  <span style={{color: "#fed700"}}>precios bajos</span>
                    </p>
                  </div>
                </div>
                
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px"
                  }}>
                  <div className="col-lg-7 col-md-7 col-sm-7">
                    <p className="d_heading">
                      Con Tovo disfruta de viajes compartidos, seguros y cómodos al alcance de tu bolsillo y a un click de distancia.
                    </p>
                  </div>
                </div>


                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0px"
                  }}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6" style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px"
                      }}>
                      <a href="https://play.google.com/store/apps/details?id=com.tovo.tovo_app">
                        <img src={Imagen_play_store} height="50px" alt="30" />
                      </a>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6" style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px"
                      }}>
                      <a href="https://apps.apple.com/us/app/tovo/id1562931806">
                        <img src={Imagen_app_store} height="50px" alt="30" />
                      </a>
                    </div>
                  </div>
                </div>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBView>
      </div>
    );
  }
}

export default Start;
